import {
    Directive,
    Input,
    Output,
    OnInit,
    OnDestroy,
    HostBinding,
    EventEmitter
} from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ServerVersionDataService } from './server-version-data.service';

@Directive({
    selector: 'app-nw-server-item',
    exportAs: 'serverVersionData'
})
export class ServerVersionDataDirective implements OnInit, OnDestroy {
    @Input() server: IServer;
    @Output() serverVersionData: EventEmitter<IVersionData> = new EventEmitter();

    _checkSbj: Subject<void> = new Subject()

    constructor(
        private _serverVersionDataSrv: ServerVersionDataService
    ) {
        this._checkSbj.asObservable()
            .pipe(tap(() => this.getVersionData()))
            .subscribe()
    }

    ngOnInit() {
        this._checkSbj.next();
    }

    ngOnDestroy() {
        this._checkSbj.complete();
    }

    async getVersionData() {
        let checkDelay = 10000;
        try {
            const versionData = await this._serverVersionDataSrv.getData(this.server.apiUrl);
            this.serverVersionData.emit(versionData);
        } catch (err) {
            this.serverVersionData.emit(null);
            checkDelay = 5000;
        }

        setTimeout(() => {
            this._checkSbj.next();
        }, checkDelay);
    }

    refresh() {
        this._serverVersionDataSrv.removeCacheItem(this.server.apiUrl);

        this.getVersionData();
    }
}
